import { IOperationModeType } from '../getCurrentUser/getCurrentUser.types';
export const getQueryKey = (operationMode: IOperationModeType) => [
  'userNotificationsList',
  operationMode,
];

export const NOTIFICATIONS_POLLING_INTERVAL = 60000; // 1 min
